import { getMe as getMeRequest } from "@/shared/api/users";
import { Module } from "vuex";
import { RootState } from "../index";

export interface IState {
  roles: string[];
  email: string;
}

const authModule: Module<IState, RootState> = {
  namespaced: true,
  state: {
    roles: [],
    email: "",
  },
  mutations: {
    SET_ME(state, payload: { roles: string[]; email: string }) {
      state.roles = payload?.roles || [];
      state.email = payload?.email || "";
    },
  },
  actions: {
    async getMe({ commit }) {
      // eslint-disable-next-line no-useless-catch
      try {
        const { data } = (await getMeRequest()) as unknown as {
          data: { roles?: string[]; email?: string };
        };
        if (data) {
          commit("SET_ME", {
            roles: data.roles || [],
            email: data.email || "",
          });
          return data;
        }
      } catch (e) {
        throw e;
      }
    },
  },
};

export default authModule;
